import { z } from 'zod';

import { MAX_SCHEDULE_MEMBERS } from './schedule-form-schema';

const ID = z.string().trim().min(1).max(64);

/**
 * `?productIds=` on /org/schedules/new: the products a "Create rotation…" hand-over starts the
 * pool with. Takes the array the router writes (`navigate({ search: { productIds } })`) or a
 * comma list typed into a link; anything malformed is dropped rather than failing the route.
 */
export const scheduleNewSearchSchema = z.object({
  productIds: z
    .union([z.array(ID), z.string().transform((v) => v.split(',').map((id) => id.trim()))])
    .transform((ids) => [...new Set(ids.filter(Boolean))].slice(0, MAX_SCHEDULE_MEMBERS))
    .optional()
    .catch(undefined),
});

export type ScheduleNewSearch = z.infer<typeof scheduleNewSearchSchema>;
